// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"J3-z","colorTextValue":"K3-z","swatches":"L3-z","collapseLink":"M3-z","isCollapsed":"N3-z","dropdown":"O3-z","disabled":"P3-z"};